import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ProgramSecureUploadPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-program-secure-upload',
  templateUrl: 'program-secure-upload.html',
})
export class ProgramSecureUploadPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramSecureUploadPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-secure-upload/program-secure-upload.ts